import React from 'react';
import { Card, CardContent } from './ui/card';
import { Sparkles } from 'lucide-react';

const GlassSection = () => {
  return (
    <section className="py-24 relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-zinc-950 via-black to-zinc-950"></div>
      
      {/* Animated background elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-orange-500/10 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-green-400/10 rounded-full blur-3xl animate-pulse delay-1000"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Glass Card */}
          <Card className="bg-white/5 backdrop-blur-xl border border-white/10 shadow-2xl overflow-hidden">
            <CardContent className="p-6 sm:p-8 md:p-12">
              <div className="flex flex-col sm:flex-row items-start sm:space-x-4 mb-6">
                <div className="w-12 h-12 bg-gradient-to-r from-orange-500 to-green-400 rounded-xl flex items-center justify-center flex-shrink-0 mb-4 sm:mb-0">
                  <Sparkles className="w-6 h-6 text-black" />
                </div>
                <div className="flex-1 w-full">
                  <h3 className="text-2xl sm:text-3xl font-black text-white mb-4">
                    Pronto a Trasformare la Tua Vita?
                  </h3>
                  <p className="text-base sm:text-lg text-gray-300 leading-relaxed mb-6 break-words">
                    Non aspettare il momento perfetto. Il momento perfetto è <span className="text-orange-500 font-bold">adesso</span>. Prenota la tua prova gratuita e scopri cosa significa allenarsi con un metodo che funziona davvero.
                  </p>
                  
                  {/* Features list */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-gradient-to-r from-orange-500 to-green-400 rounded-full flex-shrink-0"></div>
                      <span className="text-sm sm:text-base text-gray-300 break-words">Prima sessione completamente gratuita</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-gradient-to-r from-orange-500 to-green-400 rounded-full flex-shrink-0"></div>
                      <span className="text-sm sm:text-base text-gray-300 break-words">Valutazione fisica professionale</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-gradient-to-r from-orange-500 to-green-400 rounded-full flex-shrink-0"></div>
                      <span className="text-sm sm:text-base text-gray-300 break-words">Piano personalizzato preliminare</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-gradient-to-r from-orange-500 to-green-400 rounded-full flex-shrink-0"></div>
                      <span className="text-sm sm:text-base text-gray-300 break-words">Zero impegno richiesto</span>
                    </div>
                  </div>

                  {/* Stats in glass cards */}
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-4 sm:p-6 text-center">
                      <div className="text-3xl sm:text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-green-400">100+</div>
                      <div className="text-xs text-gray-500 uppercase tracking-wide mt-2 sm:mt-1 break-words">Clienti Felici</div>
                    </div>
                    <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-4 sm:p-6 text-center">
                      <div className="text-3xl sm:text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-green-400">95%</div>
                      <div className="text-xs text-gray-500 uppercase tracking-wide mt-2 sm:mt-1 break-words">Successo</div>
                    </div>
                    <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-4 sm:p-6 text-center">
                      <div className="text-3xl sm:text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-green-400">5+</div>
                      <div className="text-xs text-gray-500 uppercase tracking-wide mt-2 sm:mt-1 break-words">Anni</div>
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default GlassSection;
